import MaterialIconButton from "../../../../__snowpack__/pkg/@mui/material/IconButton.js";
import styled from "styled-components";
export const IconButtonContainer = styled(MaterialIconButton).withConfig({
  displayName: "icon-buttonstyles__IconButtonContainer",
  componentId: "sc-12vdsnm-0"
})([""]);
